import { ReactNode, useMemo } from "react";

// MUI
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CustomTheme } from "@/Auth/styles/mui.theme";
import { Box, Grid, StyledEngineProvider } from "@mui/material";

import LoginHeader from "@/Auth/Layouts/LoginHeader";
import LoginFooter from "@/Auth/Layouts/LoginFooter";

// Images
import BackgroundArtwork from "@/Auth/assets/images/framed_curves.svg";

// Styles
import "@/Auth/styles/tailwind.login.css";

const LoginContainer = ({ children }: { children: ReactNode }) => {
	// To toggle based on user preferences replace with: useMediaQuery("(prefers-color-scheme: dark)");
	const prefersDarkMode = false;

	const darkableTheme = useMemo(
		() => createTheme({ ...CustomTheme, palette: { ...CustomTheme.palette, mode: prefersDarkMode ? "dark" : "light" } }),
		[prefersDarkMode]
	);

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={darkableTheme}>
				<CssBaseline />
				<Grid container justifyContent="center" alignContent="center" className={`${prefersDarkMode ? "dark" : ""}`}>
					<Box
						className="fixed top-0 left-0 w-screen h-screen bg-white dark:bg-black -z-10 bg-no-repeat bg-cover bg-center"
						sx={{ backgroundImage: `url(${BackgroundArtwork})` }}
					></Box>

					<Box className="z-10 h-screen flex flex-col mx-5">
						<Box className="flex flex-col justify-center mt-[10vh] tall:mt-[20vh]">
							<Grid className="bg-white dark:bg-black border-[1px] rounded-[10px] border-gray-medium px-[57.03px] pb-[108px] w-[627.5px]">
								<LoginHeader />
								{children}
							</Grid>
						</Box>
						<div className="flex-grow min-h-[36px]"></div>
						<LoginFooter />
						<div className="w-full min-h-[36px]"></div>
					</Box>
				</Grid>
			</ThemeProvider>
		</StyledEngineProvider>
	);
};

export default LoginContainer;
